import * as Actions from '../actions';
// TODO REFACTOR HERE

const initialState = {
	extractedLinks: [],
	list: [],
	clustersLoaded: false,
	cluster: null,
	queue: {
		counts: {
			blocked: 0,
			completed: 0,
			queued: 0,
			running: 0,
			total: 0
		},
		data: []
	},
	nodes: {
		counts: {
			available: 0,
			busy: 0,
			down: 0,
			offline: 0,
			total: 0,
			unknown: 0
		},
		data: []
	},
	node: null,
	activities: [],
	logs: null,
	logsClusterId: null, // Track which cluster the current logs belong to
	selected: null,
	searchText: '',
	filter: null,
	quickFilters: { provider: null, region: null, tag: null, state: null },
	orgTags: [],
	error: null,
	aiErrorAnalysis: null,
	os_types: [],
	storageProviders: [],
	storageProvidersLoading: false,
	storageProvidersError: null,
	// Enhanced Volumez policy management state
	providerPolicies: {}, // { providerId: policies[] }
	providerPoliciesLoading: {}, // { providerId: boolean }
	providerPoliciesError: {}, // { providerId: error }
	selectedPolicies: {}, // { providerId: policyName }
	policyConstraints: {}, // { providerId: { policyName: constraints } }
	policyConstraintsLoading: {}, // { providerId: { policyName: boolean } }
	policyConstraintsError: {}, // { providerId: { policyName: error } }
	configurationValidation: {}, // { providerId: validationResult }
	configurationValidationLoading: {}, // { providerId: boolean }
	tabValue: null,
	clusterHealthData: {},
	clusterHealthLoading: false,
	clusterSparklines: {},
	gpuMetrics: {
		data: null,
		summary: null,
		loading: false,
		error: null
	},
	clusterMetrics: {
		data: null,
		history: [],
		loading: false,
		error: null
	},
	stressTests: {
		data: null,
		history: null,
		volumes: null,
		loading: false,
		error: null
	},
	preconfiguredDevices: [],
	// Instance availability by zone
	zoneAvailability: {
		zones: {},
		provider: null,
		region: null,
		instanceTypes: [],
		timestamp: null,
		loading: false,
		error: null,
		unableToVerify: false
	},
	// Live AWS catalog for the credential-first AWS form (see fetchAwsRegions /
	// fetchAwsCatalog). `requestKey` identifies the selection a response belongs to.
	awsCatalog: {
		regions: { credentialId: null, list: [], loading: false, error: null },
		catalog: { requestKey: null, credentialId: null, region: null, data: null, loading: false, error: null },
		// run-instances --dry-run verdicts keyed by credential|region|image|type|zone
		launchChecks: {},
		// marketplace software pricing keyed by credential|region|codes
		softwarePricing: {}
	},
	// Live Azure catalog for the credential-first Azure form (see
	// fetchAzureRegions / fetchAzureCatalog). Same requestKey contract as
	// awsCatalog above. No zones: Azure clusters place regionally.
	azureCatalog: {
		regions: { credentialId: null, list: [], loading: false, error: null },
		catalog: { requestKey: null, credentialId: null, region: null, data: null, loading: false, error: null },
		// Marketplace terms verdicts keyed by credential|publisher|offer|plan
		terms: {}
	},
	// Latest resolved Marketplace AMI for the currently-selected variant +
	// region (only used by entries whose variant config carries a
	// `marketplace_product_code`; static-region-map entries don't populate
	// this slice).
	marketplaceAmi: {
		imageId: null,
		name: null,
		creationDate: null,
		region: null,
		loading: false,
		error: null
	}
};

const clusterReducer = (state = initialState, action) => {
	switch (action.type) {
		case Actions.SET_OS_TYPES: {
			return {
				...state,
				error: null,
				os_types: action.payload
			};
		}
		// SET
		case Actions.SET_CLUSTERS_LIST: {
			return {
				...state,
				list: action.payload,
				clustersLoaded: true
			};
		}
		case Actions.SET_CLUSTER_OPTIMISTIC_STATE: {
			const { clusterId, state: newState } = action.payload;
			const updatedList = (state.list || []).map(c =>
				(c.id === clusterId || c._id === clusterId)
					? { ...c, info: { ...c.info, state: newState, deployProgress: newState === 'deploying' ? 5 : (c.info?.deployProgress || 0) } }
					: c
			);
			// Also update the single cluster view if it matches
			const updatedCluster = state.cluster && (state.cluster.id === clusterId || state.cluster._id === clusterId)
				? { ...state.cluster, info: { ...state.cluster.info, state: newState, deployProgress: newState === 'deploying' ? 5 : (state.cluster.info?.deployProgress || 0) } }
				: state.cluster;
			return {
				...state,
				list: updatedList,
				cluster: updatedCluster
			};
		}
		case Actions.SET_CLUSTER: {
			const { cluster, queue, nodes } = action.payload;
			return {
				...state,
				cluster: cluster,
				queue: {
					counts: queue ? queue.counts : {},
					data: queue ? queue.data : []
				},
				nodes: {
					counts: nodes ? nodes.counts : {},
					data: nodes ? nodes.data : []
				},
				error: null
			};
		}
		case Actions.SET_MARKET_CLUSTER: {
			const { cluster, queue, nodes } = action.payload;
			return {
				...state,
				cluster: cluster,
				queue: {
					counts: queue ? queue.counts : {},
					data: queue ? queue.data : []
				},
				nodes: {
					counts: nodes ? nodes.counts : {},
					data: nodes ? nodes.data : []
				},
				error: null
			};
		}

		case Actions.SET_CLUSTER_TOKEN: {
			return {
				...state,
				token: action.payload
			};
		}

		case Actions.SET_CLUSTER_ACTIVITIES: {
			return {
				...state,
				activities: action.payload,
				error: null
			};
		}
		case Actions.SET_LOGS: {
			// Only update logs if they belong to the current cluster or no specific cluster is tracking
			const { logs, clusterId } = action.payload;
			return {
				...state,
				logs: logs,
				logsClusterId: clusterId,
				error: null
			};
		}
		case Actions.SET_LOG_URLS: {
			return {
				...state,
				extractedLinks: action.payload
			}
		}
		case Actions.SET_NODE: {
			return {
				...state,
				node: action.payload,
				error: null
			};
		}
		case Actions.SET_SELECTED: {
			return {
				...state,
				selected: action.payload
			};
		}

		case Actions.SET_CLUSTERS_SEARCH_TEXT: {
			return {
				...state,
				searchText: action.searchText
			};
		}
		case Actions.SET_FILTER: {
			return {
				...state,
				filter: action.payload
			};
		}
		case Actions.SET_QUICK_FILTERS: {
			return {
				...state,
				quickFilters: action.payload
			};
		}
		case Actions.SET_ORG_TAGS: {
			return {
				...state,
				orgTags: action.payload
			};
		}
		case Actions.SET_CLUSTER_ERROR: {
			return {
				...state,
				error: action.payload
			};
		}
		case Actions.SET_TAB_VALUE: {
			return {
				...state,
				tabValue: action.payload
			};
		}
		case Actions.SET_AI_ERROR_ANALYSIS: {
			return {
				...state,
				aiErrorAnalysis: action.payload
			};
		}

		// STORAGE PROVIDERS
		case Actions.SET_STORAGE_PROVIDERS: {
			return {
				...state,
				storageProviders: action.payload,
				storageProvidersError: null,
				storageProvidersLoading: false
			};
		}
		case Actions.SET_STORAGE_PROVIDERS_LOADING: {
			return {
				...state,
				storageProvidersLoading: action.payload
			};
		}
		case Actions.SET_STORAGE_PROVIDERS_ERROR: {
			return {
				...state,
				storageProvidersError: action.payload,
				storageProvidersLoading: false
			};
		}
		case Actions.CLEAR_STORAGE_PROVIDERS: {
			return {
				...state,
				storageProviders: [],
				storageProvidersError: null,
				storageProvidersLoading: false
			};
		}

		// VOLUMEZ POLICY MANAGEMENT
		case Actions.SET_PROVIDER_POLICIES: {
			const { providerId, policies } = action.payload;
			return {
				...state,
				providerPolicies: {
					...state.providerPolicies,
					[providerId]: policies
				},
				providerPoliciesError: {
					...state.providerPoliciesError,
					[providerId]: null
				}
			};
		}
		case Actions.SET_PROVIDER_POLICIES_LOADING: {
			const { providerId, loading } = action.payload;
			return {
				...state,
				providerPoliciesLoading: {
					...state.providerPoliciesLoading,
					[providerId]: loading
				}
			};
		}
		case Actions.SET_PROVIDER_POLICIES_ERROR: {
			const { providerId, error } = action.payload;
			return {
				...state,
				providerPoliciesError: {
					...state.providerPoliciesError,
					[providerId]: error
				}
			};
		}
		case Actions.SET_SELECTED_POLICY: {
			const { providerId, policyName } = action.payload;
			return {
				...state,
				selectedPolicies: {
					...state.selectedPolicies,
					[providerId]: policyName
				}
			};
		}
		case Actions.SET_POLICY_CONSTRAINTS: {
			const { providerId, policyName, constraints } = action.payload;
			return {
				...state,
				policyConstraints: {
					...state.policyConstraints,
					[providerId]: {
						...state.policyConstraints[providerId],
						[policyName]: constraints
					}
				}
			};
		}
		case Actions.SET_POLICY_CONSTRAINTS_LOADING: {
			const { providerId, policyName, loading } = action.payload;
			return {
				...state,
				policyConstraintsLoading: {
					...state.policyConstraintsLoading,
					[providerId]: {
						...state.policyConstraintsLoading[providerId],
						[policyName]: loading
					}
				}
			};
		}
		case Actions.SET_POLICY_CONSTRAINTS_ERROR: {
			const { providerId, policyName, error } = action.payload;
			return {
				...state,
				policyConstraintsError: {
					...state.policyConstraintsError,
					[providerId]: {
						...state.policyConstraintsError[providerId],
						[policyName]: error
					}
				}
			};
		}
		case Actions.SET_CONFIGURATION_VALIDATION: {
			const { providerId, validationResult } = action.payload;
			return {
				...state,
				configurationValidation: {
					...state.configurationValidation,
					[providerId]: validationResult
				}
			};
		}
		case Actions.SET_CONFIGURATION_VALIDATION_LOADING: {
			const { providerId, loading } = action.payload;
			return {
				...state,
				configurationValidationLoading: {
					...state.configurationValidationLoading,
					[providerId]: loading
				}
			};
		}
		case Actions.RESET_POLICY_VALIDATION: {
			const { providerId } = action.payload;
			return {
				...state,
				selectedPolicies: {
					...state.selectedPolicies,
					[providerId]: null
				},
				policyConstraints: {
					...state.policyConstraints,
					[providerId]: {}
				},
				configurationValidation: {
					...state.configurationValidation,
					[providerId]: null
				}
			};
		}

		case Actions.SET_CLUSTER_HEALTH_DATA: {
			return {
				...state,
				clusterHealthData: action.payload
			};
		}
		case Actions.SET_CLUSTER_HEALTH_LOADING: {
			return {
				...state,
				clusterHealthLoading: action.payload
			};
		}
		case Actions.CLEAR_CLUSTER_HEALTH_DATA: {
			return {
				...state,
				clusterHealthData: {},
				clusterHealthLoading: false
			};
		}

		// CLEAR
		case Actions.CLEAR_CLUSTER: {
			return {
				...state,
				cluster: null,
				error: null
			};
		}
		case Actions.CLEAR_CLUSTER_LIST: {
			return {
				...state,
				list: null,
				clusterHealthData: {},
				error: null
			};
		}
		case Actions.CLEAR_LOGS: {
			return {
				...state,
				logs: null,
				logsClusterId: null
			};
		}
		case Actions.CLEAR_AI_ERROR_ANALYSIS: {
			return {
				...state,
				aiErrorAnalysis: null
			};
		}
		case Actions.CLEAR_ERROR: {
			return {
				...state,
				error: null
			};
		}
		case Actions.CLEAR_CLUSTER_REDUCER: {
			return initialState;
		}
		case Actions.SET_GPU_METRICS: {
			return {
				...state,
				gpuMetrics: {
					...state.gpuMetrics,
					data: action.payload
				}
			};
		}
		case Actions.SET_GPU_METRICS_SUMMARY: {
			return {
				...state,
				gpuMetrics: {
					...state.gpuMetrics,
					summary: action.payload
				}
			};
		}
		case Actions.SET_GPU_METRICS_LOADING: {
			return {
				...state,
				gpuMetrics: {
					...state.gpuMetrics,
					loading: action.payload
				}
			};
		}
		case Actions.SET_GPU_METRICS_ERROR: {
			return {
				...state,
				gpuMetrics: {
					...state.gpuMetrics,
					error: action.payload
				}
			};
		}
		case Actions.SET_CLUSTER_METRICS: {
			return {
				...state,
				clusterMetrics: {
					...state.clusterMetrics,
					data: action.payload
				}
			};
		}
		case Actions.SET_CLUSTER_METRICS_HISTORY: {
			return {
				...state,
				clusterMetrics: {
					...state.clusterMetrics,
					history: action.payload
				}
			};
		}
		case Actions.SET_CLUSTER_METRICS_LOADING: {
			return {
				...state,
				clusterMetrics: {
					...state.clusterMetrics,
					loading: action.payload
				}
			};
		}
		case Actions.SET_CLUSTER_METRICS_ERROR: {
			return {
				...state,
				clusterMetrics: {
					...state.clusterMetrics,
					error: action.payload
				}
			};
		}
		case Actions.CLEAR_CLUSTER_METRICS: {
			return {
				...state,
				clusterMetrics: {
					data: null,
					history: [],
					loading: false,
					error: null
				}
			};
		}
		case Actions.SET_CLUSTER_SPARKLINES: {
			return {
				...state,
				clusterSparklines: {
					...state.clusterSparklines,
					...action.payload
				}
			};
		}
		// STRESS TESTS
		case Actions.SET_STRESS_TEST_DATA: {
			return {
				...state,
				stressTests: {
					...state.stressTests,
					data: action.payload
				}
			};
		}
		case Actions.SET_STRESS_TEST_LOADING: {
			return {
				...state,
				stressTests: {
					...state.stressTests,
					loading: action.payload
				}
			};
		}
		case Actions.SET_STRESS_TEST_ERROR: {
			return {
				...state,
				stressTests: {
					...state.stressTests,
					error: action.payload
				}
			};
		}
		case Actions.SET_STRESS_TEST_HISTORY: {
			return {
				...state,
				stressTests: {
					...state.stressTests,
					history: action.payload
				}
			};
		}
		case Actions.SET_CLUSTER_VOLUMES: {
			return {
				...state,
				stressTests: {
					...state.stressTests,
					volumes: action.payload
				}
			};
		}
		case Actions.SET_PRECONFIGURED_DEVICES: {
			return {
				...state,
				preconfiguredDevices: action.payload
			};
		}
		// Zone Availability
		case Actions.SET_ZONE_AVAILABILITY: {
			return {
				...state,
				zoneAvailability: {
					...state.zoneAvailability,
					zones: action.payload.zones,
					provider: action.payload.provider,
					region: action.payload.region,
					instanceTypes: action.payload.instanceTypes,
					timestamp: action.payload.timestamp,
					unableToVerify: action.payload.unableToVerify || false,
					error: action.payload.error || null
				}
			};
		}
		case Actions.SET_ZONE_AVAILABILITY_LOADING: {
			return {
				...state,
				zoneAvailability: {
					...state.zoneAvailability,
					loading: action.payload
				}
			};
		}
		case Actions.SET_ZONE_AVAILABILITY_ERROR: {
			return {
				...state,
				zoneAvailability: {
					...state.zoneAvailability,
					error: action.payload
				}
			};
		}
		case Actions.CLEAR_ZONE_AVAILABILITY: {
			return {
				...state,
				zoneAvailability: {
					zones: {},
					provider: null,
					region: null,
					instanceTypes: [],
					timestamp: null,
					loading: false,
					error: null,
					unableToVerify: false
				}
			};
		}
		// AWS live catalog
		case Actions.AWS_REGIONS_LOADING: {
			return {
				...state,
				awsCatalog: {
					...state.awsCatalog,
					regions: { credentialId: action.payload.credentialId, list: [], loading: true, error: null }
				}
			};
		}
		case Actions.AWS_REGIONS_LOADED:
		case Actions.AWS_REGIONS_FAILED: {
			// Ignore a response for a credential the user has already moved away from.
			if (state.awsCatalog.regions.credentialId !== action.payload.credentialId) return state;
			return {
				...state,
				awsCatalog: {
					...state.awsCatalog,
					regions: {
						credentialId: action.payload.credentialId,
						list: action.payload.regions || [],
						loading: false,
						error: action.payload.error || null
					}
				}
			};
		}
		case Actions.AWS_CATALOG_LOADING: {
			return {
				...state,
				awsCatalog: {
					...state.awsCatalog,
					catalog: {
						requestKey: action.payload.requestKey,
						credentialId: action.payload.credentialId,
						region: action.payload.region,
						data: null,
						loading: true,
						error: null
					}
				}
			};
		}
		case Actions.AWS_CATALOG_LOADED:
		case Actions.AWS_CATALOG_FAILED: {
			if (state.awsCatalog.catalog.requestKey !== action.payload.requestKey) return state;
			return {
				...state,
				awsCatalog: {
					...state.awsCatalog,
					catalog: {
						...state.awsCatalog.catalog,
						data: action.payload.data || null,
						loading: false,
						error: action.payload.error || null
					}
				}
			};
		}
		// Azure live catalog
		case Actions.AZURE_REGIONS_LOADING: {
			return {
				...state,
				azureCatalog: {
					...state.azureCatalog,
					regions: { credentialId: action.payload.credentialId, list: [], loading: true, error: null }
				}
			};
		}
		case Actions.AZURE_REGIONS_LOADED:
		case Actions.AZURE_REGIONS_FAILED: {
			// Ignore a response for a credential the user has already moved away from.
			if (state.azureCatalog.regions.credentialId !== action.payload.credentialId) return state;
			return {
				...state,
				azureCatalog: {
					...state.azureCatalog,
					regions: {
						credentialId: action.payload.credentialId,
						list: action.payload.regions || [],
						loading: false,
						error: action.payload.error || null
					}
				}
			};
		}
		case Actions.AZURE_CATALOG_LOADING: {
			return {
				...state,
				azureCatalog: {
					...state.azureCatalog,
					catalog: {
						requestKey: action.payload.requestKey,
						credentialId: action.payload.credentialId,
						region: action.payload.region,
						data: null,
						loading: true,
						error: null
					}
				}
			};
		}
		case Actions.AZURE_CATALOG_LOADED:
		case Actions.AZURE_CATALOG_FAILED: {
			if (state.azureCatalog.catalog.requestKey !== action.payload.requestKey) return state;
			return {
				...state,
				azureCatalog: {
					...state.azureCatalog,
					catalog: {
						...state.azureCatalog.catalog,
						data: action.payload.data || null,
						loading: false,
						error: action.payload.error || null
					}
				}
			};
		}
		case Actions.AZURE_TERMS_LOADING: {
			return {
				...state,
				azureCatalog: {
					...state.azureCatalog,
					terms: { ...state.azureCatalog.terms, [action.payload.key]: { loading: true } }
				}
			};
		}
		case Actions.AZURE_TERMS_DONE: {
			return {
				...state,
				azureCatalog: {
					...state.azureCatalog,
					terms: { ...state.azureCatalog.terms, [action.payload.key]: { loading: false, ...action.payload.terms } }
				}
			};
		}
		case Actions.AZURE_TERMS_CLEAR: {
			return { ...state, azureCatalog: { ...state.azureCatalog, terms: {} } };
		}
		case Actions.AWS_LAUNCH_CHECK_LOADING:
		case Actions.AWS_LAUNCH_CHECK_DONE: {
			const entries = Object.entries(state.awsCatalog.launchChecks || {});
			// Keep the map small: the newest ~50 combinations are all the form ever needs.
			const kept = entries.length > 50 ? Object.fromEntries(entries.slice(entries.length - 50)) : state.awsCatalog.launchChecks;
			const value = action.type === Actions.AWS_LAUNCH_CHECK_LOADING ? { loading: true } : { loading: false, ...action.payload.result };
			return {
				...state,
				awsCatalog: {
					...state.awsCatalog,
					launchChecks: { ...kept, [action.payload.key]: value }
				}
			};
		}
		case Actions.AWS_LAUNCH_CHECKS_CLEAR: {
			return { ...state, awsCatalog: { ...state.awsCatalog, launchChecks: {} } };
		}
		case Actions.AWS_SOFTWARE_PRICING_LOADING:
		case Actions.AWS_SOFTWARE_PRICING_DONE: {
			const value = action.type === Actions.AWS_SOFTWARE_PRICING_LOADING ? { loading: true } : { loading: false, ...action.payload.result };
			return {
				...state,
				awsCatalog: {
					...state.awsCatalog,
					softwarePricing: { ...(state.awsCatalog.softwarePricing || {}), [action.payload.key]: value }
				}
			};
		}
		// Marketplace AMI resolution
		case Actions.SET_MARKETPLACE_AMI: {
			return {
				...state,
				marketplaceAmi: {
					...state.marketplaceAmi,
					imageId: action.payload.imageId,
					name: action.payload.name,
					creationDate: action.payload.creationDate,
					region: action.payload.region,
					// Image attributes for the image x shape compatibility matrix
					arch: action.payload.arch || null,
					virt: action.payload.virt || null,
					bootMode: action.payload.bootMode || null,
					ena: action.payload.ena == null ? null : Boolean(action.payload.ena),
					rootDeviceType: action.payload.rootDeviceType || null,
					productCodes: action.payload.productCodes || []
				}
			};
		}
		case Actions.SET_MARKETPLACE_AMI_LOADING: {
			return {
				...state,
				marketplaceAmi: { ...state.marketplaceAmi, loading: action.payload }
			};
		}
		case Actions.SET_MARKETPLACE_AMI_ERROR: {
			return {
				...state,
				marketplaceAmi: { ...state.marketplaceAmi, error: action.payload }
			};
		}
		case Actions.CLEAR_MARKETPLACE_AMI: {
			return {
				...state,
				marketplaceAmi: {
					imageId: null,
					name: null,
					creationDate: null,
					region: null,
					loading: false,
					error: null
				}
			};
		}
		// DEFAULT
		default: {
			return state;
		}
	}
};

export default clusterReducer;
